
import { crmFileSaveAPI } from '@/api/common';
import { getFileTypeIcon, fileSize as _fileSize } from '@/utils';

import axios from 'axios';

export default {
  name: 'WkUploadCell',
  components: {},
  props: {
    file: {
      type: File,
      required: true
    },
    index: Number,
    request: Function,
    complete: {
      type: Boolean,
      default: false
    },
    params: Object
  },
  data: function data() {
    return {
      percentage: 0,
      cancel: null
    };
  },

  computed: {
    handleIcon: function handleIcon() {
      return this.complete ? 'el-icon-check' : 'el-icon-close';
    },
    fileIcon: function fileIcon() {
      return getFileTypeIcon(this.file);
    },
    fileSize: function fileSize() {
      return '\uFF08' + _fileSize(this.file.size) + '\uFF09';
    }
  },
  watch: {
    file: {
      handler: function handler() {
        if (this.file && !this.complete && this.percentage == 0) {
          this.uploadFile();
        }
      },

      immediate: true
    }
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},

  methods: {
    uploadFile: function uploadFile() {
      var _this = this;

      var request = this.request ? this.request : crmFileSaveAPI;
      var params = this.params ? this.params : {};
      params.file = this.file;

      var CancelToken = axios.CancelToken;

      var self = this;
      var config = {
        onUploadProgress: function onUploadProgress(progressEvent) {
          var percentage = progressEvent.loaded / progressEvent.total * 100 | 0;
          _this.percentage = percentage;
        },
        cancelToken: new CancelToken(function executor(c) {
          self.cancel = c;
          self.$emit('cancelTokenChange', c, self.index);
        })
      };
      request(params, config).then(function (res) {
        _this.$emit('completed', _this.index, res);
      }).catch(function () {
        _this.$emit('error', _this.index);
      });
    },
    cancelRequest: function cancelRequest() {
      if (!this.complete) {
        this.cancel();
        this.$emit('delete', this.index);
      }
    }
  }
};